import React from 'react';
import _ from 'lodash';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import gitHubIcon from '../../../../../assets/images/github/github-black.svg';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../../components/Popup/PopupHeader';
import PopupBody from '../../../../components/Popup/PopupBody';
import PopupButtons from '../../../../components/Popup/PopupButtons';
import PopupButton from '../../../../components/Popup/PopupButton';
import PopupCancelButton from '../../../../components/Popup/PopupCancelButton';
import DiffMatchPatch from 'diff-match-patch';
window.diff_match_patch = DiffMatchPatch;
window.DIFF_DELETE = DiffMatchPatch.DIFF_DELETE;
window.DIFF_INSERT = DiffMatchPatch.DIFF_INSERT;
window.DIFF_EQUAL = DiffMatchPatch.DIFF_EQUAL;

require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/addon/merge/merge');
const CodeMirror = require('codemirror/lib/codemirror');

class MergeForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedFileInd: 0,
            files: props.files
        };
        this.mergeViewRef = React.createRef();
        this.mergeView = null;
    }

    componentDidMount() {
        this.updatedMergeView();
    }

    updatedMergeView = () => {
        const { selectedFileInd, files } = this.state;
        const newText = files[selectedFileInd].localContent;
        const oldText = files[selectedFileInd].remoteContent;
        const text = files[selectedFileInd].text;
        if (this.mergeView) {
            this.mergeView.edit.off("change", this.updateFileText);
        }
        this.mergeViewRef.current.innerHTML = '';
        this.mergeView = CodeMirror.MergeView(this.mergeViewRef.current, {
            value: text !== undefined ? text : newText,
            origLeft: oldText,
            orig: newText,
            lineNumbers: true,
            mode: "",
            highlightDifferences: true,
        });
        this.mergeView.edit.on("change", this.updateFileText);
    }

    selectFile = (index) => {
        this.setState({ selectedFileInd: index }, () => {
            this.updatedMergeView();
        });
    }

    cancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    updateFileText = () => {
        const { files, selectedFileInd } = this.state;
        const newFiles = [...files];
        newFiles[selectedFileInd] = {
            ...newFiles[selectedFileInd],
            text: this.mergeView.edit.getValue()
        };
        this.setState({
            files: newFiles
        });
    }

    restartMerge = () => {
        const { files, selectedFileInd } = this.state;
        const { files: initialFiles } = this.props;
        const newFiles = [...files];

        newFiles[selectedFileInd] = {
            ...initialFiles[selectedFileInd]
        };
        this.setState({
            files: newFiles
        }, () => {
            this.updatedMergeView();
        });
    }

    mergeUsingTheirs = () => {
        const { files, selectedFileInd } = this.state;
        const { files: initialFiles } = this.props;
        const newFiles = [...files];

        newFiles[selectedFileInd] = {
            ...initialFiles[selectedFileInd],
            text: initialFiles[selectedFileInd].remoteContent
        };
        this.setState({
            files: newFiles
        }, () => {
            this.updatedMergeView();
        });
    }
    mergeUsingMine = () => {
        const { files, selectedFileInd } = this.state;
        const { files: initialFiles } = this.props;
        const newFiles = [...files];

        newFiles[selectedFileInd] = {
            ...initialFiles[selectedFileInd],
            text: initialFiles[selectedFileInd].localContent
        };
        this.setState({
            files: newFiles
        }, () => {
            this.updatedMergeView();
        });
    }

    markAsResolved = () => {
        const { files, selectedFileInd } = this.state;
        const newFiles = [...files];
        newFiles[selectedFileInd].resolved = true;
        this.setState({
            files: newFiles
        });
    }

    finishMerge = () => {
        const { finishMerge } = this.props;
        const { files } = this.state;
        finishMerge(files);
    }

    render() {
        const { files, selectedFileInd } = this.state;
        const hasUnresolvedFiles = files.filter(file => file.resolved !== true).length > 0;
        return <PopupWrapper className="merge-form" >
            <PopupHeader
                title="Merge Changes"
                titleIconImg={gitHubIcon}
                onCancel={this.cancel}
            />
            <PopupBody>
                <div className="merge-form__body">
                    <div className="merge-form__body-info">
                        Resolve all conflicts to be able to finish merge
                    </div>

                    <div className="merge-form__file-panel">
                        <div className="merge-form__file-panel-title">
                            Files:
                        </div>
                        <div className="merge-form__file-panel-list">
                            {files.map(({ name, resolved }, index) => {
                                return <div
                                    key={name}
                                    className={`merge-form__file ${index === selectedFileInd && 'selected'}`}
                                    onClick={() => { this.selectFile(index); }}>
                                    {resolved ?
                                        <i className="icon icon-alan-circle-ok" /> :
                                        <i className="icon icon-alan-alert" />}
                                    {name}
                                </div>;
                            })}
                        </div>
                    </div>
                    <div className="merge-form__merge-panel">
                        <div className="merge-form__merge-panel-title">
                            <div>Remote version</div>
                            <div>Final version</div>
                            <div>Project's version</div>
                        </div>
                        <div className="merge-form__merge-view" ref={this.mergeViewRef} />
                        <div className="merge-form__merge-panel-btns">
                            <div
                                className="action-btn light-red-with-border restart-merge-btn"
                                onClick={this.restartMerge}>
                                Restart merge
                            </div>
                            <div className="merge-group">
                                <div
                                    className="action-btn light-blue-with-border resolved-with-theirs-btn"
                                    onClick={this.mergeUsingTheirs}>
                                    Merge using theirs
                            </div>
                                <div
                                    className="action-btn light-blue-with-border resolved-with-mine-btn"
                                    onClick={this.mergeUsingMine}>
                                    Merge using mine
                            </div>
                            </div>

                            <div
                                className="action-btn light-blue-with-border mark-as-resolved-btn"
                                onClick={this.markAsResolved}>
                                Mark as resolved
                            </div>
                        </div>
                    </div>
                </div>
                <PopupButtons>
                    <PopupCancelButton label="Close" action={this.cancel} />
                    <PopupButton
                        className={`${hasUnresolvedFiles && 'disabled'}`}
                        label="Finish merge"
                        action={this.finishMerge} />
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>;
    }
}

export default withClickOutsideOnOverlay(MergeForm);